import { render, staticRenderFns } from "./EDataTable4.vue?vue&type=template&id=afd46f88&scoped=true&"
import script from "./EDataTable4.vue?vue&type=script&lang=js&"
export * from "./EDataTable4.vue?vue&type=script&lang=js&"
import style0 from "./EDataTable4.vue?vue&type=style&index=0&id=afd46f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd46f88",
  null
  
)

export default component.exports